export const TASK_STATUS = {
  INPROGRESS: 'INPROGRESS',
  NOTSTARTED: 'NOTSTARTED',
  COMPLETED: 'COMPLETED'
};
